import {ChangeDetectionStrategy, ChangeDetectorRef, Component, ElementRef, OnInit, ViewChild, ViewEncapsulation} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import { ConfigService } from '@services/config/config.service';
import {SearchResultsProcessor} from '@formbird/shared';
import {AvlTraceGmapComponentDefinition} from './avl-trace-gmap.component.definition';
import {FormbirdInjectorService, SearchService} from 'formbird-services';
import {SclUtilAvlService, SclUtilGmapService} from 'formbird-sc-shared';
import {SclMapConstantService} from '../../../../formbird-mapping/src/lib/scl-map-constant.service';
import {SclUtilMapService} from '../../../../formbird-mapping/src/lib/scl-util-map.service';
import * as GoogleMapsLoader from '../../../../formbird-mapping/src/lib/google/GoogleMapsLoader.js';
import * as moment from 'moment';
import * as c3 from 'c3';
import {AbstractComponent} from '../../../../formbird-sc-shared/src/lib/components/abstract.component';
import {ComponentSetupService} from '../../../../formbird-sc-shared/src/lib/component-setup.service';
import {ChangedDocumentService} from 'formbird-services';

// import { AvlTestData } from './avl-test-data';

@Component({
  templateUrl: './avl-trace-gmap.component.html',
  styleUrls: [
    './avl-trace-gmap.component.scss'
  ],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AvlTraceGmapComponent extends AbstractComponent<AvlTraceGmapComponentDefinition> implements OnInit {

  @ViewChild('targetMap', {static: false}) target: ElementRef;
  @ViewChild('containerChart', {static: false}) containerChart: ElementRef;

  // services
  notificationService: any;
  dataService: any;
  loggedInUserService: any;

  //
  google;
  map;
  uluru = {lat: -25.344, lng: 131.036};
  vehicleIconFileField;
  vehicleMainImageFileField;
  geozonesQuery;
  geozonesData;
  geozonesName;
  vehicleMainImage = '';
  disableMouseWheel;
  projection;
  markers = [];
  vehiclesData = {};
  vehicleMarker;
  chart;
  previousData;
  paths;
  timeFormat = 'hh:mm a';
  imei = '';
  showimei = true;
  opened;
  isRequestVehicleData = true;
  isInitDateTimeField = false;
  isInitVehiclesField = true; // = true for angular version because related-document not fire when first time load component
  vehicle;
  graphPoint;
  preSize;
  vehicleData;
  dt;
  tooltipConfig;
  apiKey;
  user;


  constructor(
    public cdRef: ChangeDetectorRef,
    protected changedDocumentService: ChangedDocumentService,
    protected componentSetupService: ComponentSetupService,
    protected formbirdInjectorService: FormbirdInjectorService,
    private sclUtilGmapService: SclUtilGmapService,
    private sclUtilMapService: SclUtilMapService,
    private sclUtilAvlService: SclUtilAvlService,
    private configService: ConfigService,
    private httpClient: HttpClient,
    private searchService: SearchService
  ) {
    super(formbirdInjectorService, changedDocumentService, componentSetupService, cdRef);
    this.notificationService = this.formbirdInjectorService.get('NotificationService');
    this.dataService = this.formbirdInjectorService.get('DataService');
    this.loggedInUserService = this.formbirdInjectorService.get('LoggedInUserService');
    this.user = this.loggedInUserService.user.account;
  }

  ngOnInit() {
    this.componentSetupService.setupStandardProperties(this);

    if (!(typeof this.componentDefinition.vehicleIconFileField === 'undefined' || this.componentDefinition.vehicleIconFileField === null)) {
      this.vehicleIconFileField = this.componentDefinition.vehicleIconFileField;
    }
    if (!(typeof this.componentDefinition.tooltipsTable === 'undefined' || this.componentDefinition.tooltipsTable === null)) {
      this.tooltipConfig = this.componentDefinition.tooltipsTable;
    }
    if (!(typeof this.componentDefinition.image === 'undefined' || this.componentDefinition.image === null)) {
      this.vehicleMainImageFileField = this.componentDefinition.image;
    }
    if (!(typeof this.componentDefinition.geozones === 'undefined' || this.componentDefinition.geozones === null)) {
      if (!(typeof this.componentDefinition.geozones.filter === 'undefined' || this.componentDefinition.geozones.filter === null)) {
        this.geozonesQuery = this.componentDefinition.geozones.filter;
      }
      if (!(typeof this.componentDefinition.geozones.data === 'undefined' || this.componentDefinition.geozones.data === null)) {
        this.geozonesData = this.componentDefinition.geozones.data;
      }
      if (!(typeof this.componentDefinition.geozones.name === 'undefined' || this.componentDefinition.geozones.name === null)) {
        this.geozonesName = this.componentDefinition.geozones.name;
      }
    }
    if (!(typeof this.componentDefinition.disableMouseWheel === 'undefined' || this.componentDefinition.disableMouseWheel === null)) {
      this.disableMouseWheel = this.componentDefinition.disableMouseWheel;
    }

    const clientConfig = this.configService.clientConfig();
    if (clientConfig && clientConfig.dateFormat && clientConfig.dateFormat.time) {
      this.timeFormat = clientConfig.dateFormat.time;
    }
    this.isRequestVehicleData = true;

    this.setupChangeDetection();

    const dateTimeFieldSub = this.changedDocumentService.watch(this.componentDefinition.dateTimeField
      , this.document.documentId).subscribe(fieldValue => {
        console.log('watch dateTimeField, value = ' + fieldValue);
        this.document[this.componentDefinition.dateTimeField] = fieldValue;
        this.watchDateTimeField(fieldValue);
    });
    const avlVehiclesFieldSub = this.changedDocumentService.watch(this.componentDefinition.avlVehiclesField
      , this.document.documentId).subscribe(fieldValue => {
        console.log('watch avlVehiclesField, value = ' + fieldValue);
        this.document[this.componentDefinition.avlVehiclesField] = fieldValue;
        this.watchAvlVehiclesField(fieldValue);
    });
    this.subs.add(dateTimeFieldSub);
    this.subs.add(avlVehiclesFieldSub);

    this.loadMap(() => {
      console.log('GoogleMapsLoader center at uluru');
      if (typeof this.componentDefinition.heightNum === 'undefined' || this.componentDefinition.heightNum === null) {
        this.target.nativeElement.style.height = '180 px';
      } else {
        let height = 180 * this.componentDefinition.heightNum;
        const docHeight = document.body.scrollHeight;
        if (height > (docHeight - 180)) {
          height = docHeight - 180;
        }
        this.target.nativeElement.style.height = '' + height + 'px';
      }

      this.map = new this.google.maps.Map(this.target.nativeElement, {zoom: 4, center: this.uluru});

      // create overlayview
      const overlay = new this.google.maps.OverlayView();
      overlay.onAdd = () => {
        overlay.getPanes().markerLayer.id = 'markerLayer';
        const markersView = document.getElementById('markerLayer');
        const observer = new MutationObserver(this.markersChange.bind(this));
        const configObserver = { attributes: true, childList: true, subtree: true };
        observer.observe(markersView, configObserver);
      };
      overlay.setMap(this.map);
      this.map.addListener('zoom_changed', this.markersChange.bind(this));
      this.map.addListener('dragstart', this.markersChange.bind(this));
      this.google.maps.event.addListener(this.map, 'projection_changed', () => {
        this.projection = this.map.getProjection();
      });

      this.google.maps.event.addListener(this.map, 'mousedown', function() {
        const popupAdress: HTMLElement = document.getElementById('popup-adress');
        if (popupAdress) {
          popupAdress.style.display = 'none';
        }
      });

      const MapLabel = this.sclUtilGmapService.initMapLabel(this.google);

      if (this.geozonesQuery && this.geozonesData) {
        const options = this.sclUtilMapService.constructQueryGeoZones(this.geozonesQuery, this.document);   // testing
        this.searchService.search(options).then((data) => {
          this.sclUtilGmapService.getGeoCoors(SearchResultsProcessor, data, this.geozonesData, this.geozonesName, this.google
            , (geozones) => {
              if (geozones && geozones.length) {
                for (let i = 0 ; i < geozones.length; i++) {
                  const geozone = geozones[i];
                  if (geozone.shape === 'Point') {
                    const mapLabel: any = new MapLabel({
                        text: geozone.name,
                        position: geozone.coors[0],
                        map: this.map,
                        fontSize: 20
                    });
                    const marker = new this.google.maps.Marker({
                      position: geozone.coors[0]
                    });
                    marker.setMap(this.map);
                  } else if (geozone.shape === 'Line') {
                    if (this.geozonesName) {
                      const textCoor = this.centerOfZone(geozone.coors);
                      const mapLabel = new MapLabel({
                          text: geozone.name,
                          position: textCoor,
                          map: this.map,
                          fontSize: 20
                      });
                    }
                    const polyline = new this.google.maps.Polyline({
                      path: geozone.coors,
                      editable: false,
                      strokeColor: '#FF0000',
                      strokeOpacity: 1.0,
                      strokeWeight: 2
                    });
                    polyline.setMap(this.map);
                  } else if (geozone.shape === 'Polygon') {
                    if (this.geozonesName) {
                      const textCoor = this.centerOfZone(geozone.coors);
                      const mapLabel = new MapLabel({
                          text: geozone.name,
                          position: textCoor,
                          map: this.map,
                          fontSize: 20
                      });
                    }
                    const polyline = new this.google.maps.Polygon({
                      path: geozone.coors,
                      editable: false,
                      strokeColor: '#FF0000',
                      strokeOpacity: 1.0,
                      strokeWeight: 2
                    });
                    polyline.setMap(this.map);
                  } else {
                    console.log('not handles yet!!!');
                  }
                }
              } else {
                console.log('geozones undefined');
              }
          });
        });
      }

      this.changeDt();

    }); // end loadMap

  }

  //
  loadMap(cb) {
    // this.apiKey = 'AIzaSyDr8ovTk9O_JVvCokeaFE6nzsbhMRBCQm8'; // avl-dev server
    this.apiKey = 'AIzaSyDLF3KfOk7figOYUQAudATOTTqCbzf1ylc'; // localhost:3000
    GoogleMapsLoader.KEY = this.apiKey;
    GoogleMapsLoader.LIBRARIES = 'places';
    // GoogleMapsLoader.SENSOR = true;
    GoogleMapsLoader.load((google) => {
      this.google = google;
      cb();
    });
  }

  watchDateTimeField(newVal) {
    console.log('newVal = ' + newVal);
    if (!this.isInitDateTimeField) {
      this.isInitDateTimeField = true;
      return;
    }
    if (newVal == null) { newVal = new Date(); }
    this.dt = newVal;
    this.changeDt();
  }

  watchAvlVehiclesField(value) {
    console.log('watchAvlVehiclesField, value = ' + value);
    if (!this.isInitVehiclesField) {
      this.isInitVehiclesField = true;
      return;
    }
    if (value && value.length > 0) {
      this.vehicle = value;
      this.isRequestVehicleData = true;
      this.changeDt();
    }
  }

  markersChange() {
    if (this.vehicleMarker && !this.vehicleMarker.img) {
      const listImgElement = document.querySelectorAll('#markerLayer img');
      for (const id in listImgElement) {
        if (listImgElement.hasOwnProperty(id)) {
          const element: any = listImgElement[id];
          if (element.__src__ === this.vehicleMarker.icon.url) {
            this.vehicleMarker.img = element;
          }
        }
      }
    }
  }
  centerOfZone(coordinates) {
    let lat = 0;
    let lng = 0;
    if (coordinates.length <= 0) {
      return;
    }
    for (let i = 0; i < coordinates.length; i++) {
      lat = lat + coordinates[i].lat();
      lng = lng + coordinates[i].lng();
    }
    return new this.google.maps.LatLng(lat / coordinates.length, lng / coordinates.length);
  }
  open($event) {
    $event.preventDefault();
    $event.stopPropagation();
    this.opened = true;
  }
  clearMap() {
    if (this.markers) {
      for (const id in this.markers) {
        if (this.markers.hasOwnProperty(id)) {
          this.markers[id].setMap(null);
        }
      }
    }
    if (this.paths) {this.paths.setMap(null); }


    if (this.vehicleMarker) {
      this.vehicleMarker.setMap(null);
      this.vehicleMarker = null;
    }
  }
  changeDt() {
    console.log('changeDt, scope.dt = ' + this.dt);
    if (this.graphPoint) {
      this.graphPoint = null;
    }


    this.vehicle = this.document[this.componentDefinition.avlVehiclesField];
    if (this.vehicle && this.vehicle.length > 0 && this.vehicle[0].documentId) {
        if (this.isRequestVehicleData) {
            console.log('in here 11111');
            const params = {
              functionName: 'getLastEvent',
              componentDocumentName: 'sc-avl-trace-gmap-web-component',
              functionParameters: [this.componentDefinition.dataService, this.vehicle[0].documentId]
            };
            this.httpClient.post('api/execute', params).subscribe( (dataResult: any) => {
              console.log('apiGetLastEvent , result data = ');
              console.log(dataResult);
              // dataResult = [{ test: 'test' }]; // test test
              const data = dataResult; // dataResult is array
              if (data && data.length > 0) {
                console.log('getVehicleData: ' + this.vehicle[0].documentId);
                const options = this.sclUtilMapService.constructQueryDocument([this.vehicle[0].documentId], this.document);

                // apiGetVehicleData(documentId)
                this.searchService.search(options)
                    .then( (results) => {
                      // results = AvlTestData.vehicleData; // test test
                      console.log('changeDt, searchService result = ', results);
                      if (results && results.data && results.data.hits && results.data.hits.hits && results.data.hits.hits.length > 0) {
                        const itemData = results.data.hits.hits[0]._source;
                        if (!itemData) { return; }
                        this.vehicleData = itemData;

                        if (this.vehicleMainImageFileField && this.vehicleData[this.vehicleMainImageFileField]
                            && Array.isArray(this.vehicleData[this.vehicleMainImageFileField])
                            && this.vehicleData[this.vehicleMainImageFileField].length > 0) {

                          const imageData = this.vehicleData[this.vehicleMainImageFileField][0];
                          this.vehicleMainImage = '/api/getFile/' + imageData.fileNo + '/' + imageData.fileName;
                        } else {
                          this.vehicleMainImage = '';
                        }
                        if (this.vehicleData) {
                          this.vehicleData = this.vehicleData;
                        }
                      } else {
                        console.error('Something wrong, can not get vehicle info with documentId: ');
                      }
                      const currentDate = new Date(data[0].eventDate);
                      // this will trigger scope.watch('dt') and this function get called again, this time got to else, not here
                      this.dt = currentDate;
                      this.document[this.componentDefinition.dateTimeField] = currentDate;

                      this.detectChanges();

                    }, (err) => {
                      console.error('error options when getting vehicles data :' + options.filter);
                      console.error(err);
                    }
                );
              } else {
                this.clearMap();
                if (this.chart) {
                  this.chart.unload();
                }
                this.notificationService.printMessage('No event found');
              }
            }, (err) => {
              console.error('error query current location :');
              console.error(err);
            });
        } else {
            console.log('in here 22222');
            const currentDate = new Date(this.dt);
            this.searchEvent(currentDate);
        }
        this.isRequestVehicleData = false;
    }
  }
  // request to get events
  searchEvent(selectedDate) {

    console.log('Searching event for date: ' + selectedDate);
    const format = 'YYYY-MM-DD';


    let startDate = new Date(selectedDate);
    startDate.setHours(0);
    startDate.setMinutes(0);
    startDate.setSeconds(1);

    startDate = new Date(startDate.getTime());
    console.log('Offset Time: ' + startDate.getTimezoneOffset()
     + '\tstartDate.getTime(): ' + startDate.getTime() + '\tTestDate: ' + startDate);

    const endDate = new Date(startDate);
    endDate.setDate(startDate.getDate() + 1);

    const startDateFormat = startDate.toISOString();
    const endDateFormat = endDate.toISOString();

    const params = {
        functionName: 'getAvlEvent',
        componentDocumentName: 'sc-avl-trace-gmap-web-component',
        functionParameters: [this.componentDefinition.dataService, this.vehicle[0].documentId, startDateFormat, endDateFormat]
    };

    console.log('calculated start date: ' + startDateFormat + '\tcalculated end date: ' + endDateFormat);
    // getAvlEvent
    this.httpClient.post('api/execute', params).subscribe( (res: any) => {
      // res = AvlTestData.points; // test test
      console.log('searchEvent , res = ', res);
      const customData = res; // res is array

      const dataes = [];
      if (customData) {

        console.log('Event number is ' + customData.length);


        if (customData.length === 0) {
          this.notificationService.printMessage('No event found this date');
        } else {
          console.log('first event:\n' + JSON.stringify(customData[0]));
        }

        if (customData.length > 2) {
            console.log('true start date: ' + customData[0].eventDate);
            console.log('true end date: ' + customData[customData.length - 1].eventDate);
        }


        for (let i = 0; i < customData.length; i++) {
          const valJson = customData[i];

          const object = this.sclUtilMapService.parseAVLData_New(valJson);

          const icon = this.sclUtilMapService.checkAVLSpeed(SclMapConstantService.AVL_SPEED_BEGINNING,
              parseFloat(object.speedKPH).toFixed(5),
              parseFloat(object.heading),
              parseFloat(this.vehicleData.imeiSpeedA),
              parseFloat(this.vehicleData.imeiSpeedB),
              parseFloat(this.vehicleData.imeiSpeedC),
              parseFloat(this.vehicleData.imeiSpeedD),
              parseFloat(this.vehicleData.imeiSpeedE)
          );
          object.imeiDocumentsRel = valJson.imeiDocumentsRel;
          object.icon = icon;

          dataes.push(object);
        }
        this.showMap(dataes);
      }
    }, (err) => {
      console.log('Error: ', err);
    });
  }

  showVehicle(location, rotation, text) {
    if (!this.vehicleMarker) {
      let url = '';
      if (this.vehicleData && this.vehicleIconFileField && this.vehicleData[this.vehicleIconFileField]
          && Array.isArray(this.vehicleData[this.vehicleIconFileField])
          && this.vehicleData[this.vehicleIconFileField].length > 0) {
        const imageData = this.vehicleData[this.vehicleIconFileField][0];
        url = '/api/getFile/' + imageData.fileNo + '/' + imageData.fileName;
      }

      const icon: any = {
        url: url,
        labelOrigin: new this.google.maps.Point(40, 70)
      };

      console.log('==================');
      console.log(icon.size);

      this.vehicleMarker = new this.google.maps.Marker({

          map: this.map,
          icon: icon,
          position: location
      });
    } else {
      this.vehicleMarker.setPosition(location);
      if (this.vehicleMarker.img) {
        this.vehicleMarker.img. style.transform = 'rotate(' + rotation + 'deg)';
        if (this.vehicleMarker.icon.size) {
          this.vehicleMarker.icon.anchor = new this.google.maps.Point(this.vehicleMarker.icon.size.width / 2
            , this.vehicleMarker.icon.size.height / 2);
        }

      }
    }
    this.map.panTo(location);
    this.vehicleMarker.setLabel({
      text: text,
      color: '#222222',
      fontSize: '0px'
    });
    const popupAdress = document.getElementById('popup-adress');
    if (popupAdress) {
      if (text) {
          popupAdress.innerHTML = text;
          popupAdress.style.display = 'unset';
          if (this.projection) {
            const worldPoint = this.projection.fromLatLngToPoint(location);
            // popup_adress.style.top = worldPoint.x+"px";
            // popup_adress.style.left = worldPoint.y+"px";
            popupAdress.style.marginLeft = -popupAdress.offsetWidth / 2 + 'px';
            popupAdress.style.marginTop = popupAdress.offsetHeight / 2 + 'px';
            // popup_adress.style.marginTop = "40px";
          }
      } else {
        popupAdress.style.display = 'none';
      }
    }
  }

  // show data
  showMap(data) {
    this.clearMap();
    if (data.length === 0) {
      if (this.chart) {
        this.chart.unload();
      }
      return;
    }
    this.previousData = data;

    const self = this;
    const listCoordinate = [];
    for (let i = 0; i < data.length ; i++) {

      const coordinate = new this.google.maps.LatLng(data[i].latitude, data[i].longitude);
      listCoordinate.push(coordinate);

      const arrow = new this.google.maps.Marker({
        map: this.map,
        icon: data[i].icon,
        position: coordinate
      });
      arrow.data = data[i];

      arrow.addListener('mouseover', function() {
        let name = '';
        let url = '';
        let deviceName = '';
        const relatedvehicleData: any = self.sclUtilAvlService.getRelatedDocument(data, 'vehicle');
        if (relatedvehicleData) {
          url = '#/form/' + relatedvehicleData.documentId;
          deviceName = relatedvehicleData.name;
        }
        name += '<a href=' + url + '><b>' + deviceName + '</b></a><br>';

        const tooltipImg = self.vehicleMainImage;
        let imgtooltip = tooltipImg;
        if (tooltipImg !== '') {
          imgtooltip = '<img src=' + tooltipImg + '/>';
        }


        const emei = self.toDataRow('IMEI', this.data.imei);
        const addressRow = self.toDataRow('Address', '');
        const gps = self.toDataRow('GPS', this.data.latitude.toString() + ', ' + this.data.longitude.toString());
        const time = self.toDataRow('Time', self.formatTime(this.data.eventDate));
        const speed = self.toDataRow('Speed', this.data.speedKPH);
        const heading = self.toDataRow('Heading', this.data.heading);
        const imageRow = self.toDataRow('Image', imgtooltip);
        const arrayValue = [];
        arrayValue.push(addressRow);
        arrayValue.push(gps);
        arrayValue.push(time);
        arrayValue.push(speed);
        arrayValue.push(heading);

        if (self.tooltipConfig) {
          for (const key1 in self.tooltipConfig) {
            if (self.tooltipConfig.hasOwnProperty(key1)) {
              const key2 = self.tooltipConfig[key1];
              let value = self.sclUtilMapService.parseHandlerBar(key2, self.vehicleData) ;
              value = value ? value : '';
              const tooltipRow = self.toDataRow(key1, value);
              arrayValue.push(tooltipRow);
            }
          }
        }

        arrayValue.push(imageRow);
        const text = name + self.toHtmlTable(arrayValue);
        const infoWindow = new self.google.maps.InfoWindow({
            content: text,
            position: this.position
        });
        arrow.infoWindow = infoWindow;
        infoWindow.open(self.map, this);

        const location = [this.data.longitude, this.data.latitude];
        self.convertGPSToAddress(location, (data1: any) => {
          if (data1 === null) { return; }
          if (arrow.infoWindow) {
            const temp = {properties: {}};
            const address = self.sclUtilMapService.fillGoogleAddress(data1.data.results[0], temp);
            let text1 = (address.properties.streetNo) ? address.properties.streetNo : '';
            text1 += ' ' + ((address.properties.street) ? address.properties.street : '');
            text1 += '<br>' + ((address.properties.suburb) ? address.properties.suburb  : '');
            text1 += '<br> ' + ((address.properties.state) ? address.properties.state : '');
            text1 += ', ' + ((address.properties.country) ? address.properties.country : '');
            addressRow.col2 = text1;
            const arrayValue1 = [];
            arrayValue1.push(addressRow);
            arrayValue1.push(gps);
            arrayValue1.push(time);
            arrayValue1.push(speed);
            arrayValue1.push(heading);

            if (self.tooltipConfig) {
              for (const key1 in self.tooltipConfig) {
                if (self.tooltipConfig.hasOwnProperty(key1)) {
                  const key2 = self.tooltipConfig[key1];
                  let value = self.sclUtilMapService.parseHandlerBar(key2, self.vehicleData) ;
                  value = value ? value : '';
                  const tooltipRow = self.toDataRow(key1, value);
                  arrayValue1.push(tooltipRow);
                }
              }
            }

            arrayValue1.push(imageRow);
            text1 = name + self.toHtmlTable(arrayValue1);
            arrow.infoWindow.setContent(text1);
          }
        });
      });
      arrow.addListener('mouseout', () => {
        if (arrow.infoWindow) {
          arrow.infoWindow.close();
        }
      });
      this.markers.push(arrow);
    }

    if (this.paths) {
      this.paths.setMap(null);
    }

    this.paths = new this.google.maps.Polyline({
      path: listCoordinate,
      editable: false,
      strokeColor: '#FF0000',
      strokeOpacity: 1.0,
      strokeWeight: 2,
      map: this.map
    });

    if (listCoordinate.length > 0) {
      this.map.setCenter(listCoordinate[0]);
      this.map.setZoom(12);
    }

    const speedData: any = [];
    const events = [];
    const x = [];
    speedData.push('Speed ');
    x.push('x');

    for (let k = 0; k < data.length; k++) {
      const event = data[k];

      const eventDate = new Date(event.eventDate);
      x.push(eventDate.getTime());
      const speed = event.speedKPH;

      if (speed > -1) {
          speedData.push(speed);
      } else {
          speedData.push(0);
      }
      events.push(event);
    }

    const startTime = new Date(data[0].eventDate);
    const endTime = new Date(data[data.length - 1].eventDate);

    const timeValues = [];
    const timeSpaced = 1; // 1 hours
    // if (preSize[0] < 400) {
    //     timeSpaced = 3;
    // }
    // else if (preSize[0] < 800) {
    //     timeSpaced = 2;
    // }

    const count = Math.round((endTime.getTime() - startTime.getTime()) / 1000 / 60 / 60 / timeSpaced);
    console.log('EndTime: ' + endTime.getHours() + '\tStartTime: ' + startTime.getHours() + '\tcount: ' + count);
    timeValues.push(startTime.getTime());

    for (let k = 1; k < count; ++k) {
      const temp = new Date(startTime);
      temp.setHours(startTime.getHours() + (k * timeSpaced));
      temp.setMinutes(0);
      timeValues.push(temp.getTime());
    }

    timeValues.push(endTime.getTime());

    let previousHoveredPoint;
    let innerClick = false;



    // chart
    this.chart = c3.generate({
        bindto: this.containerChart[0],
        size: {
            height: 200
        },
        data: {
            x: 'x',
            columns: [
                x,
                speedData
            ],
            onclick:  (d, i) => {
                console.log('onclick inside');
                console.log(d);
                console.log(i);

                const eve = events[d.index];
                if (!eve) {
                    previousHoveredPoint = undefined;
                    return;
                }

                const lat = eve.latitude;
                const lon = eve.longitude;
                innerClick = true;
                this.onClickGraph([lon, lat], eve.heading);
            },
            onmouseover: (d, element) => {

                const eve = events[d.index];
                if (!eve) {
                    previousHoveredPoint = undefined;
                    return;
                }
                previousHoveredPoint = eve;
                const lat = eve.latitude;
                const lon = eve.longitude;
                const location = new this.google.maps.LatLng(lat, lon);
                this.showVehicle(location, eve.heading, '');
            }
        },
        axis: {
            x: {
                type: 'timeseries',
                tick: {
                    fit: false,
                    // count: 23,
                    format: '%H:%M',
                    values: timeValues
                }
            }
        },
        zoom: {
            enabled: true

        }
    });

    // event click chart
    this.containerChart.nativeElement.onclick = () => {
        console.log('onclick');
        innerClick = false;
        setTimeout(() => {
            if (!innerClick) {
                if (previousHoveredPoint) {
                    const lat = previousHoveredPoint.latitude;
                    const lon = previousHoveredPoint.longitude;
                    this.onClickGraph([lon, lat], previousHoveredPoint.heading);
                }
            }
        }, 0.015);

    };
  }

  convertGPSToAddress(coor, cb) {
    const lat = parseFloat(coor[1]);
    const lon = parseFloat(coor[0]);

    const link = 'https://maps.googleapis.com/maps/api/geocode/json?latlng=' + lat + ',' + lon + '&key=' + this.apiKey;
    this.httpClient.get(link).subscribe((data: any) => {
        if (data.status === 'OK' ) {
          if (cb && typeof cb === 'function') {
            cb(data);
          }
        } else {
          console.log('Error: ' + data.error_message);
          cb(null);
        }
    }, error => {
      console.log('Error : ' + error);
      cb(null);
    });
  }
  // function clickGraph vs get address
  onClickGraph(location, heading) {
    this.convertGPSToAddress(location, (data) => {
      if (data === null) {
        return;
      }
      console.log('convertGPSToAddress');
      console.log(data);
      const temp = {properties: {}};
      const address = this.sclUtilMapService.fillGoogleAddress(data.data.results[0], temp);
      console.log('address: ');
      console.log(address);
      let text = (address.properties.streetNo) ? address.properties.streetNo : '';
      text += ' ' + ((address.properties.street) ? address.properties.street : '');
      text += '<br> ' + ((address.properties.suburb) ? address.properties.suburb  : '');
      text += '<br> ' + ((address.properties.state) ? address.properties.state : '');
      text += ', ' + ((address.properties.country) ? address.properties.country : '');
      console.log(text);
      const latlng = new this.google.maps.LatLng(location[1], location[0]);
      this.showVehicle(latlng, heading, text);
    });
  }

  // Request get vehicle data
  toDataRow(col1, col2) {
    return { col1, col2 };
  }
  toHtmlTable(array) {
    const style = '';
    let tableText = '<table style="width:100%" class = "table-popup">';
    for (let i = 0 ; i < array.length; i++) {
      tableText += '<tr>';
      tableText += '<td class = "table-popup">' + array[i].col1 + '</td>';
      tableText += '<td class = "table-popup">' + array[i].col2 + '</td>';
      tableText += '</tr>';
    }
    tableText += '</table>';
    return tableText;
  }
  formatTime(time) {
    const  longDate = 'h:mm:ss a';
    const timeReturn = moment(time).format(longDate);
    return timeReturn;
  }

  showToolTip(tooltip: any, formFieldContainer: any, labelContainer: any) {
    return (labelContainer.offsetWidth <= formFieldContainer._elementRef.nativeElement.scrollWidth);
  }

  toggleTooltip(tooltip: any) {
    setTimeout(() => {
      tooltip.toggle();
    });
  }
}
